import { FC, createContext, useContext } from 'react';

import { SettlementBillingItemMetaData } from '~services/billingItem/types';

import {
  DialogGenerateLiquidationContextValue,
  DialogGenerateLiquidationProps,
} from './types';

const DialogGenerateLiquidationContext =
  createContext<DialogGenerateLiquidationContextValue>({
    metadata: { lotCounter: null, footerNotes: null },
    liquidationData: {
      name: '',
      companyId: null,
      companyIntegrationStoreId: null,
      giverCompanyId: null,
      billingItems: [],
    },
    open: false,
    onClose: () => {},
    onSuccesGenerate: () => {},
  });

export const useDialogGenerateLiquidationContext =
  (): DialogGenerateLiquidationContextValue =>
    useContext(DialogGenerateLiquidationContext);

const DialogGenerateLiquidationtProvider: FC<
  DialogGenerateLiquidationProps & {
    metadata: SettlementBillingItemMetaData;
  }
> = ({ children, ...restProps }) => {
  return (
    <DialogGenerateLiquidationContext.Provider value={restProps}>
      {children}
    </DialogGenerateLiquidationContext.Provider>
  );
};

export default DialogGenerateLiquidationtProvider;
